import React from 'react';

const ProgressCircle = ({ percentage, totalFiles, uploadedFiles, failedCount, processingErrorStatus }) => {
  const radius = 50; // Radius of the circle
  const strokeWidth = 5; // Width of the stroke
  const normalizedRadius = radius - strokeWidth * 0.5; // Adjusted radius
  const circumference = normalizedRadius * 2 * Math.PI; // Circumference of the circle
  const strokeDashoffset = circumference - (percentage / 100) * circumference; // Offset for the stroke
  const isSuccess = percentage === 100 && failedCount === 0 && uploadedFiles > 0 && uploadedFiles >= totalFiles && processingErrorStatus === 200;
  const finalStatusFailed = percentage === 100 && (failedCount !== 0 || uploadedFiles === 0 || uploadedFiles < totalFiles);

  return (
    <svg height={radius * 2} width={radius * 2}>
      <circle
        stroke={isSuccess ? "green" : "#e6e6e6"}//"#e6e6e6" // Change color to green if success
        fill="transparent"
        strokeWidth={strokeWidth}
        r={normalizedRadius}
        cx={radius}
        cy={radius}
      />
      <circle
        stroke={isSuccess ? "green" : finalStatusFailed?"red": "black"}  //black// Change color to green if success
        fill="transparent"
        strokeWidth={strokeWidth}
        r={normalizedRadius}
        cx={radius}
        cy={radius}
        strokeDasharray={circumference + ' ' + circumference}
        strokeDashoffset={strokeDashoffset}
        className='progress-circle-animation' // Add a class for styling
      />
      <text
        x="50%"
        y="50%"
        textAnchor="middle"
        stroke={"black"}
        dy=".3em"
        className='progress-text-size'
      >
        {/* {isSuccess ? "Success" : `${percentage}%`} */}
        {isSuccess
          ? "Success"
          : (typeof totalFiles === "undefined"
            ? `${percentage}%`
            : `${uploadedFiles === undefined ? 0 : uploadedFiles}/${totalFiles}`)}       
      </text>
    </svg>
  );
};

export default ProgressCircle;
